import { createDefaultFormatters, createStandardConfig } from './utils'

/**
 * United Kingdom Address Configuration
 */
export const GB_CONFIG = createStandardConfig({
  countryCode: 'GB',
  countryName: 'United Kingdom',
  requiresStreetNumber: false,
  formatters: createDefaultFormatters({ address2Style: 'address2First' }),
  fieldOverrides: {
    address1: {
      googleTypes: ['street_number', 'route', 'street_address'],
      preferLongName: true,
      errorKey: 'address-config.street-address-required'
    },
    address2: {
      googleTypes: ['subpremise', 'premise'],
      labelKey: 'address-config.flat-unit'
    },
    city: {
      googleTypes: [
        'postal_town',
        'locality',
        'sublocality_level_1',
        'administrative_area_level_2'
      ]
    },
    stateOrProvince: {
      required: false,
      preferLongName: true,
      labelKey: 'address-config.county'
    },
    postalCode: {
      labelKey: 'address-config.postcode',
      errorKey: 'address-config.postcode-required'
    }
  },
  addressPrecision: 'postalCode'
})
